import React from 'react';
import { Outlet } from 'react-router-dom';

import './style.sass';

import violetLogo from 'assets/img/icons/violet-logo.svg';
import { Routes } from 'src/types/routes';

export const AnonymLayout = () => {
    const onClickLogo = () => {
        window.location.assign(Routes.Home);
    };

    return (
        <section className="anonym-layout">
            <div className="anonym-layout__logo" onClick={onClickLogo}>
                <img src={violetLogo} />
            </div>
            <Outlet />
        </section>
    );
};
